
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { adminDeleteUyeSurucu } from "../../../features/admin2/admin2Slice";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100% !important;
      padding: 10px 10px !important;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);

      .row {
        width: 100%;
        gap: 15px;
        display: flex;

        .col {
          flex: 1;
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
          text-align: center;
        }

        .col-delete{
          text-decoration: underline;
          color: var(--color-main);
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-md);
          cursor: pointer;
        }
      }

      .more-icon{
        font-size: 1.4rem;
        color: ${({theme}) => theme.mainTextColor};
      }
    }
  }
`;

const MobilUyeSuruculerContainer = ({ data, uyeItemData }) => {

  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  return (
    <Container theme={theme}>
    {
      uyeItemData?.tckn !== data?.tckn &&
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">{data.adSoyadUnvan  || "-"}</div>
            <div className="col">{data.phoneNumber || "-"}</div>
            <div className="col">{data.tckn || "-"}</div>
            <div className="col">-</div>
            <div className="col">{data.adressContent || "-"}</div>
            <div className="col">{data.il}/{data.ilce}</div>
            <div className="col">{data.ehliyet || "-"}</div>
            <div className="col">{data.srcBelgesi || "-"}</div>
            <div className="col">Belgeler</div>
            <div className="col col-delete" onClick={()=> {dispatch(adminDeleteUyeSurucu({uyeId: uyeItemData.id, driverId: data.id}))}}>Sil</div>
          </div>
        </div>
      </div>
    }
    </Container>
  );
};

export default MobilUyeSuruculerContainer;